import { FunctionalComponent, h } from "preact";
import style from "./style.scss";

const Ribbon: FunctionalComponent = () => {
  return <div className={style.ribbon} />;
};

export default Ribbon;
